const SceneBase = require("./scene-base.js");

class SceneCarousel extends SceneBase {
    static type() {
        return "scenecarousel";
    }
}

module.exports = SceneCarousel;